import * as React from "react"

const DefaultHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={124.417}
    height={195.739}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 2410 3791"
    {...props}
  >
    <path
      d="M123 3609c149 18 616 69 1077 69 597 0 972-48 1096-67V1208c-48-59-197-264-214-544-14-228 16-366 31-434-83-28-230-76-378-103-54 329-279 565-554 565-277 0-491-224-548-558-86 20-163 47-223 68-28 10-53 19-73 25-39 12-61 19-112 39 40 186 63 315 53 463-18 252-128 429-165 482l9 2398zM1610 175c-88 49-233 102-443 94-189-7-325-55-409-98 60 246 221 407 424 407 200 0 367-165 428-403z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M123 3609c149 18 616 69 1077 69 597 0 972-48 1096-67V1208c-48-59-197-264-214-544-14-228 16-366 31-434-83-28-230-76-378-103-54 329-279 565-554 565-277 0-491-224-548-558-86 20-163 47-223 68-28 10-53 19-73 25-39 12-61 19-112 39 40 186 63 315 53 463-18 252-128 429-165 482l9 2398zm501-874V1281h295v573h573v-573h295v1454h-295v-636H919v636H624zm986-2559c-88 49-233 102-443 94-189-7-325-55-409-98 60 246 221 407 424 407 200 0 367-165 428-403zM621 21v-5l31-2c10-2 21-4 32-6l27-4 7 6 17-1c0 6 1 11 1 16 28 21 172 121 436 131 318 11 456-129 461-135l2-2v-9h8l10-10 29 4c206 27 424 103 507 132l5 2c54 19 42 74 33 114-14 62-42 190-29 405 17 287 198 490 200 492l15 16v2541l-46 9c-16 3-411 77-1163 77-564 0-1136-75-1141-76l-49-7L4 1173l12-16c1-2 135-175 153-437 10-145-15-269-60-477l-10-46 43-19c90-39 117-47 166-62 19-6 42-14 69-23 65-23 151-53 248-75z"
      style={{
        fill: "#252422",
        fillRule: "nonzero",
      }}
    />
  </svg>
);

export default DefaultHome;
